
export default {
    path: 'ov/:rid',
    name: 'project-overview',props: true,
    component: () => import("./ProjectOverview"),
}